(() => {
    class Tab {
        constructor(root, listContainer, tabs, id) {
            this.elts = {
                root,
                listContainer,
                tabs,
                buttons: []	
            }

            this.id = id;
            this.buttonIdList = [];
            this.currentIndex = null;
        }

        static settings = {
            buttonId: 'p-tab',
            panelId: 'p-tabpanel',
            openClass: 'is-open'
        }

        init() {
            this.elts.tabs.forEach((tab, i) => {
                const heading = tab.getAttribute('data-heading');
                if (!heading) return;

                this.createBtn(heading, i);
                this.createTab(tab, i);
            });

            this.elts.listContainer.removeAttribute('data-tablist')
            this.elts.listContainer.setAttribute('role', 'tablist');
            this.elts.listContainer.setAttribute('aria-owns', this.buttonIdList.join(' '));

            this.open(0, false, true);
        }

        createBtn(text, i) {
            const button = document.createElement('button');
            const buttonId = `${Tab.settings.buttonId}-${this.id}-${i}`;
            
            button.setAttribute('type', 'button');
            button.setAttribute('role', 'tab');
            button.setAttribute('aria-controls', `${Tab.settings.panelId}-${this.id}-${i}`);
            button.setAttribute('tabindex', '-1');
            button.classList.add('link', 'full-unstyled-link');
            button.textContent = text;
            button.id = buttonId;
            
            this.buttonIdList.push(buttonId);
            this.elts.listContainer.append(button);
            this.elts.buttons.push(button);
            this.bindBtnEvents(button, i);
        }

        createTab(tab, i) {
            tab.setAttribute('role', 'tabpanel');
            tab.setAttribute('aria-labelledby', `${Tab.settings.buttonId}-${this.id}-${i}`);
            tab.setAttribute('tabindex', '0');
            tab.removeAttribute('data-tab');
            tab.removeAttribute('data-heading');
            tab.id = `${Tab.settings.panelId}-${this.id}-${i}`;
        }

        open(index = 0, moveFocus = false, init = false) {
            if (!this.currentIndex) {
                this.currentIndex = 0;
            } else if (index === this.currentIndex) {
                return;
            }

            const tabs = this.elts.tabs;
            const btns = this.elts.buttons;

            if (!tabs[index] || !tabs[this.currentIndex]) return;
    
            tabs[this.currentIndex].classList.remove(Tab.settings.openClass);
            btns[this.currentIndex].setAttribute('tabindex', '-1');
            btns[this.currentIndex].setAttribute('aria-selected', 'false');

            tabs[index].classList.add(Tab.settings.openClass);
            btns[index].setAttribute('tabindex', '0');
            btns[index].setAttribute('aria-selected', 'true');

            this.currentIndex = index;

            if (moveFocus) {
                btns[index].focus({preventScroll: true});
            }

            if (!init) {
                this.elts.root.dispatchEvent(
                    new CustomEvent('tab-open', {
                      detail: {
                        index: this.currentIndex,
                        tab: tabs[index]
                      },
                    })
                );
            }            
        }

        bindBtnEvents(button, i) {
            button.addEventListener('click', this.open.bind(this, i));

            button.addEventListener('keydown', (e) => {
                let nextIndex = 0;
                if (!(e.keyCode === 39 || e.keyCode === 37)) return;

                if (e.keyCode === 39 && i !== this.elts.tabs.length - 1) {
                    // Next
                    nextIndex = i + 1
                } else if (e.keyCode === 37) {
                    // Previous
                    if (i === 0) {
                        nextIndex = this.elts.tabs.length - 1;
                    } else {
                        nextIndex = i - 1;
                    }
                }

                this.open(nextIndex, true);
            });			
        }
    }

    /* *** */

    window.addEventListener('DOMContentLoaded', () => {
        const roots = document.querySelectorAll('.js-cm-tab');
        
        if (roots.length < 1) return;

        roots.forEach((root, index) =>  {
            const tabs = root.querySelectorAll('[data-tab]');
            const tabList = root.querySelector('[data-tablist]');

            if (!tabList) return;
            const tabInstance = new Tab(root, tabList, Array.from(tabs), index);
            tabInstance.init();
        });        
    });
})();